module.exports = __webpack_public_path__ + "static/img/img_logo_2.c25fa51a.png";